import { humanise } from "./format";
import { estimateSummary } from "./jobs";
import type { Lead } from "./supabase";

const SOURCE_LABEL: Record<string, string> = { instant_quote: "Instant quote", website: "Website form" };

/** Where a lead came from: "Instant quote", "Website form", or a configurable form ("form:book-a-call" is "Book a call form"). */
export function leadSource(s: string): string {
  if (SOURCE_LABEL[s]) return SOURCE_LABEL[s];
  if (s.startsWith("form:")) return `${humanise(s.slice(5))} form`;
  return humanise(s);
}

/** One line about what the enquirer wants: the estimate (instant quotes), the services picked, or the form used. */
export function leadSummary(l: Lead): string {
  const estimate = estimateSummary(l);
  if (estimate) return estimate;
  if (l.services.length) return l.services.map(humanise).join(", ");
  return l.details?.length || l.message ? "Website enquiry" : "No details";
}
